<template>
  <div class="payUPaySuccess">
    <div class="text-center mt-5" v-if="successState">
      <h3 class="text-center">Tu asesoría está por confirmarse</h3>
      <h5>Pronto recibirás un correo electrónico con la confirmación</h5>
      <p>Te recomendamos preparar tus dudas y preguntas antes de tu asesoría, recuerda ingresar a tiempo y esperar a tu asesor en caso de que aún no esté en línea en el momento de tu ingreso.</p>
      <button type="button" class="btn btn-primary mt-5" @click="returnAzzap">Volver a Azzap</button>
    </div>
  </div>
</template>

<script>
import { servicesAR } from "@/components/services/servicesAR";

export default {
  name: "PayuPaySuccess",
  data: () => ({
    successState: false,
    failState: false
  }),
  props: {},
  computed: {
    cart() {}
  },
  methods: {
    returnAzzap() {
      /*  window.open(
        "https://azzap.mx/client/index.html#/schedule/list",
        "_BLANK"
      );*/

      window.close();
    }
  },
  async created() {
    console.log("succesPAyUPage");
    console.log(this.$store.state.route);
    console.log(this.$store.state.route.query.message);

    if (this.$store.state.route.query.message == "APPROVED") {
      this.successState = true;
    }

    if (this.$store.state.route.query.message == "PENDING") {
      this.successState = true;
    }

    if (this.$store.state.route.query.message == "DECLINED") {
      window.close();
    }

    var dat = JSON.stringify({
      id: "okTransaction",
      status: this.$store.state.route.query.message,
      success: true
    });
    console.log(dat);

    window.top.postMessage(dat, "*");
  }
};
</script>


<style scoped>
</style>